import * as angular from "angular";
import * as _ from "lodash";
import { GroupService } from "../services/group.service";
import { Team } from "./team.model";
import { User } from "./user.model";
import { DialogUtils } from "../helper/dialog.helper";
import { Assignment } from "./assignment.model";

export class Group {
    public readonly requestIgnoreList = ["modelsUtils", "dialog", "Team"];

    public gid: string | null = null;
    public fid: string | null = null;
    public gname = "";
    public points: any = null;
    public gstatus = "Active";
    public team: Team;
    public filters: object | undefined;
    public user: User;
    public assignments: Assignment[];
    public editable: boolean = false;
    public created: any;
    public timestamp: String;
    public color: string;

    public relevance?: any;
    public statuses?: any;
    public refreshingContacts?: boolean;
    public size?: any;
    public contacts?: any;
    public num_houseoccupants?: any;
    public num_houses?: any;
    public houses?: any;
    public houseoccupants?: any;

    private $q: any;
    private modelsUtils: any;

    private resource: GroupService;

    constructor(
        GroupService: GroupService,
        $q: any,
        ModelsUtils: any,
        data?: any
    ) {
        this.$q = $q;
        this.modelsUtils = ModelsUtils;
        this.resource = GroupService;

        this.setData(data);
    }

    getID(): string {
        return this.gid;
    }

    setData(groupData?: object): void {
        _.merge(this, groupData);

        // _.merge combines arrays index by index, so a boundary with fewer
        // vertices than before would keep the old trailing ones.
        if (groupData && "points" in groupData) {
            this.points = groupData["points"];
        }

        if (this.filters) {
            if (typeof this.filters === "string") {
                this.filters = JSON.parse(this.filters);
            }
        }

        if (this.user) {
            this.user = this.modelsUtils.user(this.user);
        }
        if (!!groupData["assignments"] && groupData["assignments"].length > 0) {
            let assignments = groupData["assignments"];
            this.assignments = [];
            angular.forEach(assignments, (assignment: any) => {
                if (assignment.status != "Deleted")
                    this.assignments.push(
                        this.modelsUtils.assignment(assignment)
                    );
            });
        } else {
            this.assignments = [];
        }
    }
    update(): Promise<Group> {
        const deferred = this.$q.defer();
        this.resource.update(this).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.team = null;
                    this.user = null;
                    this.setData(json.data);

                    if (this.user) {
                        this.user = this.modelsUtils.user(this.user);
                    }
                    if (this.team) {
                        this.team = this.modelsUtils.team(this.team);
                    }
                    deferred.resolve(this);
                } else {
                    deferred.reject(this.modelsUtils.group(json));
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    toggleTeam(team: Team): void {
        if (this.team && this.team.tid == team.tid) {
            this.team = null; // turn off team if you click while selected.
        } else {
            this.team = team;
        }
    }

    addMembers(data: object, dialogUtils: DialogUtils): Promise<Group> {
        const deferred = this.$q.defer();
        this.resource.addMembers(this.gid, data).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.setData(json.data);
                    if (this.created && this.team && this.team.tid) {
                        this.askToSplit(dialogUtils);
                    }
                    deferred.resolve(this);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    askToSplit(dialogUtils): void {
        if (!this.fid) {
            dialogUtils.show({
                component: "vc-segment-group",
                clickOutsideToClose: true,
                locals: {
                    gid: this.gid,
                    created: true,
                },
                class: "large-dialog",
            });
        }
    }

    type(): string {
        return this.points && this.points.length ? "Map" : "Filter";
    }

    isDynamic(): boolean {
        return angular.isDefined(this.filters) && this.filters != null;
    }

    isTurfList(): boolean {
        return this.points && this.points.length;
    }
    isMultiPolygon(): boolean {
        return this.points && this.points.length && this.points[0].length > 2;
    }
}
